var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-wrap"},[_c('QrCode',{attrs:{"text":_vm.source,"size":_vm.codeSize}}),_vm._v(" "),_c('div',[_c('el-button',{staticClass:"code-btn",attrs:{"type":"primary"},on:{"click":_vm.print}},[_vm._v("打印")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-116b0aab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/code/TicketCode.vue
// module id = null
// module chunks = 